<app-loader>

</app-loader>
<div class="app h-video-editor">
    <div id="wrapper" class="h-video-editor">
        <main-header *ngIf="isVisibleHeader"></main-header>
        <div class="m-body iPoneWrapper fixed-header-body">
            <router-outlet></router-outlet>
        </div>
        <main-footer *ngIf="showFooter"></main-footer>
    </div>
</div>